import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { LogNodeModel } from "../models/logNodeModel";
import AuthService from './authService';

class LogFileService {
  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getAllNodes() {
    return axios({
      url: `logFile/getAll/`,
      method: 'get', headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getLogFileData(logNode: LogNodeModel) {
    return axios({
      url: `logFile/getLogFile`,
      method: 'post',
      responseType: 'blob',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache'
      },
      data: JSON.stringify(logNode)
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default LogFileService;
